import React, { useContext } from "react";
import { GridLegacy as Grid, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { IPreferences } from "../../../../logic/api";
import NotchedCard from "../../../../components/cards/NotchedCard/NotchedCard";
import { DriverAvailabilityManagementCard } from "./DriverAvailabilityManagementCard";
import styles from "../../styles";
import { SessionContext } from "../../../../utility/useSession";
import { ReleaseFlag, useReleaseManagement } from "@/utility/feature-management";


interface DriverAvailabilitySettingsProps {
    onSave: (data: Partial<IPreferences>) => Promise<boolean>;
}

export const DriverAvailabilitySettings: React.FC<DriverAvailabilitySettingsProps> = ({
    onSave
}) => {
    const { t } = useTranslation();
    const isDriverAvailabilitySettingsReleased = useReleaseManagement(ReleaseFlag.releaseSettingsDriverAvailability);

    const session = useContext(SessionContext);
    if (!session.current.site?.preferences.driver_shift_tracker_enabled) {
        return null;
    }

    return (
        <Grid item xs={12}>
            <NotchedCard
                label={isDriverAvailabilitySettingsReleased ? t("menuItems.driverAvailability") : t("menuItems.tasks")}
                containerProps={{ 'data-testid': 'driver-availability-settings-card' }}
                style={styles.card}
            >
                <Grid container>
                    <Grid item xs={12}>
                        <Box sx={{ mt: 1 }}>
                            <DriverAvailabilityManagementCard onSave={onSave} />
                        </Box>
                    </Grid>
                </Grid>
            </NotchedCard>
        </Grid>
    );
};
